import { getUserProfileSkeleton } from "@skyportal/auth-web-client";
import { AppAction, AppStateSlice, SET_USER_PROFILE } from "./app.types";

const initState: AppStateSlice = {
  userProfile: getUserProfileSkeleton(),
};

export default function AppReducer(state: AppStateSlice = initState, action: AppAction): AppStateSlice {
  switch (action.type) {
    case SET_USER_PROFILE: {
      return {
        ...state,
        userProfile: action.payload,
      };
    }
    default:
      return state;
  }
}
